import React from "react";
import { ArrowUpRight, BarChart3, Bell, Image as ImageIcon, Plus, Search } from "lucide-react";
import CMSLayout from "@/components/cms/CMSLayout";

const stats = [
  { title: "Posting Aktif", value: "128", subtitle: "+12% minggu ini" },
  { title: "Pengunjung Hari Ini", value: "3.4K", subtitle: "+8% dari kemarin" },
  { title: "Draft Menunggu", value: "14", subtitle: "2 butuh review" },
];

const recentPosts = [
  {
    title: "Peluncuran layanan baru",
    meta: "Diterbitkan • 2 jam lalu",
    status: "Published",
  },
  {
    title: "Tips optimasi SEO landing page",
    meta: "Diedit • 4 jam lalu",
    status: "Draft",
  },
  {
    title: "Koleksi portofolio terbaru",
    meta: "Diproses • Hari ini",
    status: "Review",
  },
];

const activity = [
  { title: "Rina menambahkan 3 foto baru", time: "10 menit lalu" },
  { title: "Admin mengubah hero section", time: "1 jam lalu" },
  { title: "Artikel 'Peluncuran layanan' disetujui", time: "3 jam lalu" },
];

const CMSPage = () => {
  return (
    <CMSLayout
      active="Dashboard"
      breadcrumb="CMS / Dashboard"
      title="Selamat datang di panel konten"
      headerActions={
        <>
          <div className="flex items-center gap-2 rounded-full border border-slate-700 bg-slate-950/60 px-3 py-2 text-sm text-slate-300">
            <Search size={16} />
            <span>Cari konten...</span>
          </div>
          <button className="rounded-full border border-slate-700 p-2.5 text-slate-300 transition hover:bg-slate-800">
            <Bell size={18} />
          </button>
          <button className="flex items-center gap-2 rounded-full bg-cyan-500 px-4 py-2 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
            <Plus size={16} /> Tambah Baru
          </button>
        </>
      }
    >
      <section className="grid gap-4 md:grid-cols-3">
        {stats.map((item) => (
          <div
            key={item.title}
            className="rounded-3xl border border-slate-800 bg-gradient-to-br from-slate-900 to-slate-800 p-5 shadow-lg shadow-black/20"
          >
            <p className="text-sm text-slate-400">{item.title}</p>
            <div className="mt-3 flex items-end justify-between">
              <p className="text-3xl font-semibold text-white">{item.value}</p>
              <div className="rounded-full bg-cyan-500/10 px-2 py-1 text-xs text-cyan-300">
                {item.subtitle}
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="grid gap-6 xl:grid-cols-[1.5fr_0.9fr]">
        <div className="rounded-3xl border border-slate-800 bg-slate-900/70 p-5">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-400">Konten terbaru</p>
              <h2 className="text-xl font-semibold text-white">Daftar posting</h2>
            </div>
            <button className="rounded-full border border-slate-700 px-3 py-2 text-sm text-slate-300 transition hover:bg-slate-800">
              Kelola Semua
            </button>
          </div>

          <div className="mt-4 space-y-3">
            {recentPosts.map((post) => (
              <div
                key={post.title}
                className="flex flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-950/70 p-4 sm:flex-row sm:items-center sm:justify-between"
              >
                <div>
                  <p className="font-medium text-white">{post.title}</p>
                  <p className="mt-1 text-sm text-slate-400">{post.meta}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-slate-800 px-3 py-1 text-xs font-medium text-slate-200">
                    {post.status}
                  </span>
                  <button className="rounded-full p-2 text-slate-400 transition hover:bg-slate-800 hover:text-white">
                    <ArrowUpRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="rounded-3xl border border-slate-800 bg-slate-900/70 p-5">
          <div className="flex items-center gap-2 text-cyan-300">
            <BarChart3 size={18} />
            <p className="text-sm font-medium">Aktivitas terbaru</p>
          </div>
          <div className="mt-4 space-y-3">
            {activity.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl border border-slate-800 bg-slate-950/60 p-3"
              >
                <p className="text-sm text-white">{item.title}</p>
                <p className="mt-1 text-xs text-slate-400">{item.time}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
        <div className="rounded-3xl border border-slate-800 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 p-5">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-cyan-300">Quick publish</p>
              <h3 className="text-xl font-semibold text-white">Siap untuk publikasi?</h3>
            </div>
            <button className="rounded-full bg-white/10 px-3 py-2 text-sm text-white transition hover:bg-white/20">
              Preview
            </button>
          </div>
          <p className="mt-3 text-sm text-slate-300">
            Gunakan panel ini untuk memantau content yang sedang dalam proses dan
            mempublikasikannya dengan lebih cepat.
          </p>
        </div>

        <div className="rounded-3xl border border-slate-800 bg-slate-900/70 p-5">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-slate-400">Media library</p>
              <h3 className="text-xl font-semibold text-white">12 asset baru</h3>
            </div>
            <div className="rounded-full bg-emerald-500/10 px-2 py-1 text-xs text-emerald-300">
              Terbaru
            </div>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-3">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="flex aspect-square items-center justify-center rounded-2xl border border-slate-800 bg-slate-950/70 text-slate-400"
              >
                <ImageIcon size={24} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </CMSLayout>
  );
};

export default CMSPage;
